import pick from 'lodash/pick';
import flatten from 'lodash/flatten';
import { IInvitationModel } from './model';

export default (self: IInvitationModel) => ({
  // the same filter groups (and labels) as the Users list
  get userRoleFilterTags() {
    return self.role ? [self.role] : [];
  },
  get userOrganizationFilterTags() {
    return self.organization?.name ? [self.organization.name] : [];
  },
  get filterTags() {
    return [...self.userRoleFilterTags, ...self.userOrganizationFilterTags].map((tag) => tag.toLowerCase());
  },
  get searchString() {
    const searchFields = ['email', 'role', 'organizationName'];
    return flatten(Object.values(pick(self, searchFields)))
      .join(' ')
      .toLowerCase();
  },
  get organizationName() {
    if (!self.organization) {
      return '';
    }
    return self.organization.name;
  },
  get userName() {
    if (!self.user) {
      return '';
    }
    return self.user.presentName;
  }
});
